<ion-button
  (click)="goBack()"
  class="button"
  [ngClass]="customClass"
  fill="outline"
>
  <i [ngClass]="faIconClass"></i>
  {{ text }}
</ion-button>
